module.exports = __webpack_public_path__ + "static/bg01-4bf7f21391b8aa1730840d34f5305d2b.jpg";